import { Filter } from '../filter';
import { ErrorType, FieldValues } from '../types';

export class RegexpFilter implements Filter<string> {
    constructor(public regexp: RegExp) {}

    async validate(fieldValue: string, otherFields: FieldValues): Promise<Array<ErrorType>> {
        if (!this.regexp.test(fieldValue)) {
            return [{ code: 'format', expectedFormat: this.regexp.source }];
        }
        return [];
    }
}
